<template>
  <b-card>
    <b-row>
      <b-col
        cols="12"
        md="4"
      >
        <h4 class="card-title mb-0 pt-50">
          Edit Employee</h4>
      </b-col>
      <b-col
        cols="12"
        md="6 ml-auto"
      >
        <div class="d-flex align-items-center justify-content-end">
          <b-button
            variant="primary"
            :to="{ name: 'parent-task-view', params: { parent_type_id: 3, parent_id: $route.params.id }}"
            class="mr-1 min-w-100"
          >
            Tasks
          </b-button>
          <b-button
            variant="primary"
            :to="{ name: 'new-create-task', params: {id: $route.params.id}}"
            class="mr-1 min-w-120"
          >
            Create Task
          </b-button>
          <b-button
            variant="outline-secondary"
            @click="back"
          >
            Back
          </b-button>
        </div>
      </b-col>
    </b-row>
    <hr>
    <validation-observer ref="simpleRules">
      <b-form class="ex-large">
        <app-timeline>
          <app-timeline-item class="pb-1">
            <div class="d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0">
              <h6>Personal Details</h6>
            </div>
            <b-row>
              <b-col
                cols="12"
                md="6"
                lg="4"
              >
                <b-form-group>
                  <label>First Name</label>
                  <validation-provider
                    v-slot="{ errors }"
                    name="First Name"
                    rules="required|min:2"
                  >
                    <b-form-input
                      id="first_name"
                      v-model="addEmployee.first_name"
                      :state="errors.length > 0 ? false:null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                cols="12"
                md="6"
                lg="4"
              >
                <b-form-group>
                  <label>Middle Name</label>
                  <b-form-input
                    id="middle_name"
                    v-model="addEmployee.middle_name"
                  />
                </b-form-group>
              </b-col>
              <b-col
                cols="12"
                md="6"
                lg="4"
              >
                <b-form-group>
                  <label>Last Name</label>
                  <validation-provider
                    v-slot="{ errors }"
                    name="Last Name"
                    rules="required|min:2"
                  >
                    <b-form-input
                      id="last_name"
                      v-model="addEmployee.last_name"
                      :state="errors.length > 0 ? false:null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                cols="12"
                md="6"
                lg="4"
              >
                <b-form-group>
                  <label>Email</label>
                  <validation-provider
                    v-slot="{ errors }"
                    name="Email"
                    rules="required|email"
                  >
                    <b-form-input
                      id="email"
                      v-model="addEmployee.email_address"
                      :state="errors.length > 0 ? false:null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                cols="12"
                md="6"
                lg="4"
              >
                <b-form-group>
                  <label>Phone</label>
                  <validation-provider
                    v-slot="{ errors }"
                    name="Phone"
                    rules="required|integer|digits:10"
                  >
                    <b-form-input
                      id="phone"
                      v-model="addEmployee.phone_number"
                      :state="errors.length > 0 ? false:null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                cols="12"
                md="6"
                lg="4"
              >
                <b-form-group>
                  <label>Gender</label>
                  <validation-provider
                    v-slot="{ errors }"
                    name="Gender"
                    rules="required"
                  >
                    <v-select
                      id="gender"
                      v-model="addEmployee.gender_id"
                      :options="genders"
                      :reduce="item => item.id"
                      :clearable="false"
                      placeholder="Select"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                cols="12"
                md="6"
                lg="4"
              >
                <b-form-group
                  id="date_of_birth"
                >
                  <label>Date of Birth</label>
                  <validation-provider
                    v-slot="{ errors }"
                    name="Date of Birth"
                    rules="required"
                  >
                    <flat-pickr
                      v-model="date_of_birth"
                      class="form-control"
                      :config="$store.state.notGraterThanToday"
                      placeholder="MM-DD-YYYY"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                cols="12"
                md="6"
                lg="4"
              >
                <b-form-group>
                  <label>SSN</label>
                  <validation-provider
                    v-slot="{ errors }"
                    name="SSN"
                    :rules="user.isAdmin() ? 'required|integer|digits:9' : ''"
                  >
                    <b-form-input
                      id="ssn"
                      v-model="addEmployee.ssn"
                      :state="errors.length > 0 ? false:null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                cols="12"
                md="6"
                lg="4"
              >
                <b-form-group
                  id="employee_start_date"
                >
                  <label>Employee Start Date</label>
                  <validation-provider
                    v-slot="{ errors }"
                    name="Employee Start Date"
                    rules="required"
                  >
                    <flat-pickr
                      v-model="employee_start_date"
                      class="form-control"
                      :config="$store.state.config"
                      placeholder="MM-DD-YYYY"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                cols="12"
                md="6"
                lg="4"
              >
                <b-form-group
                  id="employee_end_date"
                >
                  <label>Employee End Date</label>
                  <b-input-group>
                    <flat-pickr
                      v-model="employee_end_date"
                      class="form-control"
                      :config="$store.state.config"
                      placeholder="MM-DD-YYYY"
                      :clear-button="true"
                    />
                    <b-input-group-append>
                      <b-button
                        class="px-1 outline-grey"
                        variant="outline-secondary"
                        @click="removeEmployeeEndDate"
                      >
                        <feather-icon icon="XIcon" />
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col
                cols="12"
                md="6"
                lg="4"
              >
                <b-form-group
                  id="contract_start_date"
                >
                  <label>Contract Start Date</label>
                  <b-input-group>
                    <flat-pickr
                      v-model="contract_start_date"
                      class="form-control"
                      :config="$store.state.config"
                      placeholder="MM-DD-YYYY"
                      :clear-button="true"
                    />
                    <b-input-group-append>
                      <b-button
                        class="px-1 outline-grey"
                        variant="outline-secondary"
                        @click="removeContractStartDate"
                      >
                        <feather-icon icon="XIcon" />
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col
                cols="12"
                md="6"
                lg="4"
              >
                <b-form-group
                  id="contract_end_date"
                >
                  <label>Contract End Date</label>
                  <b-input-group>
                    <flat-pickr
                      v-model="contract_end_date"
                      class="form-control"
                      :config="$store.state.config"
                      placeholder="MM-DD-YYYY"
                      :clear-button="true"
                    />
                    <b-input-group-append>
                      <b-button
                        class="px-1 outline-grey"
                        variant="outline-secondary"
                        @click="removeContractEndDate"
                      >
                        <feather-icon icon="XIcon" />
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col
                cols="12"
                md="6"
                lg="4"
              >
                <b-form-group>
                  <label>Status</label>
                  <validation-provider
                    v-slot="{ errors }"
                    name="Status"
                    rules="required"
                  >
                    <v-select
                      id="status"
                      v-model="addEmployee.status_id"
                      :options="status"
                      :reduce="item => item.id"
                      :clearable="false"
                      placeholder="Select"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                cols="12"
                md="6"
                lg="4"
              >
                <b-form-group>
                  <label>End Client</label>
                  <validation-provider
                    v-slot="{ errors }"
                    name="End Client"
                  >
                    <v-select
                      id="end_client"
                      v-model="addEmployee.client_id"
                      :options="endClients"
                      :reduce="item => item.id"
                      :clearable="true"
                      placeholder="Select"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                cols="12"
                md="6"
                lg="4"
              >
                <b-form-group>
                  <label>Main Skill</label>
                  <validation-provider
                    v-slot="{ errors }"
                    name="Main Skill"
                    rules="required"
                  >
                    <v-select
                      id="role"
                      v-model="addEmployee.skill_ids"
                      :options="skills"
                      :reduce="item => item.id"
                      multiple
                      :clearable="false"
                      placeholder="Select"
                      @input="skillSelected"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                cols="12"
                md="6"
                lg="4"
              >
                <b-form-group>
                  <label>Passport Number</label>
                  <b-form-input
                    id="passport_number"
                    v-model="addEmployee.passport_number"
                  />
                </b-form-group>
              </b-col>
              <b-col
                cols="12"
                md="6"
                lg="4"
                class="mt-2"
              >
                <b-form-checkbox
                  id="visa_validated"
                  v-model="addEmployee.is_billable"
                >
                  Is Billable
                </b-form-checkbox>
              </b-col>
            </b-row>
          </app-timeline-item>

          <app-timeline-item
            variant="info"
            class="pb-1"
          >
            <div class="d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0">
              <h6>Secondary Skills</h6>
            </div>
            <div
              v-for="(technology, index) in addEmployee.technologies"
              :id="technology.id"
              :key="technology.id"
              class="d-flex"
            >
              <div class="left w-100">
                <b-row>
                  <b-col
                    cols="12"
                    md="6"
                    lg="4"
                  >
                    <b-form-group>
                      <label>Skill</label>
                      <validation-provider
                        v-slot="{ errors }"
                        name="Skill"
                        rules="required"
                      >
                        <v-select
                          v-model="technology.technology_id"
                          :options="technologies"
                          :reduce="item => item.id"
                          :clearable="false"
                          placeholder="Select"
                          @input="technologyTypeMatch(technology.technology_id, index)"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col
                    cols="12"
                    md="6"
                    lg="4"
                  >
                    <b-form-group>
                      <label>Experience</label>
                      <validation-provider
                        v-slot="{ errors }"
                        name="Experience"
                        rules="required"
                      >
                        <money
                          id="experience"
                          v-model="technology.experience"
                          :min="0"
                          :step="0.5"
                          v-bind="money1"
                          class="form-control"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col
                    cols="12"
                    md="6"
                    lg="4"
                  >
                    <b-form-group>
                      <label>Rating</label>
                      <validation-provider
                        v-slot="{ errors }"
                        name="Rating"
                        rules="required"
                      >
                        <money
                          id="rating"
                          v-model="technology.rating"
                          :min="0"
                          :step="0.5"
                          v-bind="money1"
                          class="form-control"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                </b-row>
              </div>
              <div class="right mt-2 ml-1">
                <b-button
                  v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                  variant="outline-danger"
                  class="btn-icon rounded-circle"
                  @click="removeEmployeeSkill(index)"
                >
                  <feather-icon
                    icon="XIcon"
                  />
                </b-button>
              </div>
            </div>
            <div>
              <b-button
                id="add_employee_skill"
                variant="outline-primary"
                class="btn-icon mr-1"
                @click="addEmployeeSkill"
              >
                <feather-icon icon="PlusIcon" />
                Add Skill
              </b-button>
            </div>
          </app-timeline-item>

          <app-timeline-item
            variant="success"
            class="pb-1"
          >
            <div class="d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0">
              <h6>Visa Details</h6>
            </div>
            <b-row>
              <b-col
                cols="12"
                md="6"
                lg="4"
              >
                <b-form-group>
                  <label>Type</label>
                  <validation-provider
                    v-slot="{ errors }"
                    name="Type"
                    rules="required"
                  >
                    <v-select
                      id="visa_type"
                      v-model="addEmployee.visa.type_id"
                      :options="visaTypes"
                      :reduce="item => item.id"
                      :clearable="false"
                      placeholder="Select"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                cols="12"
                md="6"
                lg="4"
              >
                <b-form-group>
                  <label>Expiry Date</label>
                  <b-input-group>
                    <flat-pickr
                      v-model="visa_expairy_date"
                      class="form-control"
                      :config="$store.state.config"
                      placeholder="MM-DD-YYYY"
                      :clear-button="true"
                    />
                    <b-input-group-append>
                      <b-button
                        class="px-1 outline-grey"
                        variant="outline-secondary"
                        @click="removeVisaExpairyDate"
                      >
                        <feather-icon icon="XIcon" />
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col
                cols="12"
                md="6"
                lg="4"
                class="mt-2"
              >
                <b-form-checkbox
                  v-model="addEmployee.visa.validated"
                >
                  Validated
                </b-form-checkbox>
              </b-col>
            </b-row>
          </app-timeline-item>

          <app-timeline-item
            variant="warning"
            class="pb-1"
          >
            <div class="d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0">
              <h6>Contact Information</h6>
            </div>
            <b-row>
              <b-col
                cols="12"
                md="6"
                lg="4"
              >
                <b-form-group>
                  <label>Address 1</label>
                  <validation-provider
                    v-slot="{ errors }"
                    name="Address 1"
                    rules="required"
                  >
                    <b-form-input
                      id="address_address1"
                      v-model="addEmployee.address.address1"
                      :state="errors.length > 0 ? false:null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                cols="12"
                md="6"
                lg="4"
              >
                <b-form-group>
                  <label>Address 2</label>
                  <b-form-input
                    id="address_address"
                    v-model="addEmployee.address.address2"
                  />
                </b-form-group>
              </b-col>
              <b-col
                cols="12"
                md="6"
                lg="4"
              >
                <b-form-group>
                  <label>City</label>
                  <validation-provider
                    v-slot="{ errors }"
                    name="City"
                    rules="required"
                  >
                    <b-form-input
                      id="address_city"
                      v-model="addEmployee.address.city"
                      :state="errors.length > 0 ? false:null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                cols="12"
                md="6"
                lg="4"
              >
                <b-form-group>
                  <label>State</label>
                  <validation-provider
                    v-slot="{ errors }"
                    name="State"
                    rules="required"
                  >
                    <v-select
                      id="address_state_id"
                      v-model="addEmployee.address.state_id"
                      :options="states"
                      :reduce="item => item.id"
                      :clearable="false"
                      placeholder="Select"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                cols="12"
                md="6"
                lg="4"
              >
                <b-form-group>
                  <label>Zip Code</label>
                  <validation-provider
                    v-slot="{ errors }"
                    name="Zip Code"
                    rules="required|integer|digits:5"
                  >
                    <b-form-input
                      id="address_zip_id"
                      v-model="addEmployee.address.zip_id"
                      :state="errors.length > 0 ? false:null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
          </app-timeline-item>

          <app-timeline-item
            variant="danger"
            class="pb-1"
          >
            <div class="d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0">
              <h6>Additional Contact Information</h6>
            </div>
            <div
              ref="form"
              class="repeater-form"
            >
              <b-row
                v-for="(contactInfo, index) in addEmployee.contact_information"
                :id="contactInfo.id"
                :key="contactInfo.id"
                ref="row"
              >
                <b-col cols="12">
                  <div class="d-flex">
                    <div class="left">
                      <b-row>
                        <b-col
                          cols="12"
                          md="6"
                          lg="4"
                        >
                          <b-form-group>
                            <label>Contact Type</label>
                            <validation-provider
                              v-slot="{ errors }"
                              :name="'Contact Type' + index"
                              rules="required"
                            >
                              <v-select
                                id="contact_info_type"
                                v-model="addEmployee.contact_information[index].type_id"
                                :options="contactTypes"
                                :reduce="item => item.id"
                                :clearable="false"
                                placeholder="Select"
                                @input="contactTypeMatch(addEmployee.contact_information[index].type_id, index)"
                              />
                              <small
                                class="text-danger"
                                v-text="errors[0] !== undefined ? errors[0].replace('Contact Type' + index, 'Contact Type') : ''"
                              />
                            </validation-provider>
                          </b-form-group>
                        </b-col>
                        <b-col
                          cols="12"
                          md="6"
                          lg="4"
                        >
                          <b-form-group>
                            <label>Contact Name</label>
                            <validation-provider
                              v-slot="{ errors }"
                              :name="'Contact Name' + index"
                              rules="required"
                            >
                              <b-form-input
                                id="contact_info_contact_name"
                                v-model="contactInfo.contact_name"
                                :state="errors.length > 0 ? false:null"
                              />
                              <small
                                class="text-danger"
                                v-text="errors[0] !== undefined ? errors[0].replace('Contact Name' + index, 'Contact Name') : ''"
                              />
                            </validation-provider>
                          </b-form-group>
                        </b-col>
                        <b-col
                          cols="12"
                          md="6"
                          lg="4"
                        >
                          <b-form-group>
                            <label>Email</label>
                            <validation-provider
                              v-slot="{ errors }"
                              :name="'Email' + index"
                              rules="required|email"
                            >
                              <b-form-input
                                id="contact_info_email_address"
                                v-model="contactInfo.email_address"
                                :state="errors.length > 0 ? false:null"
                                type="email"
                              />
                              <small
                                class="text-danger"
                                v-text="errors[0] !== undefined ? errors[0].replace('Email' + index, 'Email') : ''"
                              />
                            </validation-provider>
                          </b-form-group>
                        </b-col>
                        <b-col
                          cols="12"
                          md="6"
                          lg="4"
                        >
                          <b-form-group>
                            <label>Phone</label>
                            <validation-provider
                              v-slot="{ errors }"
                              :name="'Phone' + index"
                              rules="required|integer|digits:10"
                            >
                              <b-form-input
                                id="contact_info_phone_number"
                                v-model="contactInfo.phone_number"
                                :state="errors.length > 0 ? false:null"
                              />
                              <small
                                class="text-danger"
                                v-text="errors[0] !== undefined ? errors[0].replace('Phone' + index, 'Phone') : ''"
                              />
                            </validation-provider>
                          </b-form-group>
                        </b-col>
                        <b-col
                          cols="12"
                          md="6"
                          lg="4"
                        >
                          <b-form-group>
                            <label>Address 1</label>
                            <validation-provider
                              v-slot="{ errors }"
                              :name="'Address 1' + index"
                              rules="required"
                            >
                              <b-form-input
                                id="contact_info_address"
                                v-model="contactInfo.address.address1"
                                :state="errors.length > 0 ? false:null"
                              />
                              <small
                                class="text-danger"
                                v-text="errors[0] !== undefined ? errors[0].replace('Address 1' + index, 'Address 1') : ''"
                              />
                            </validation-provider>
                          </b-form-group>
                        </b-col>
                        <b-col
                          cols="12"
                          md="6"
                          lg="4"
                        >
                          <b-form-group>
                            <label>Address 2</label>
                            <b-form-input
                              id="contact_info_address_address2"
                              v-model="contactInfo.address.address2"
                            />
                          </b-form-group>
                        </b-col>
                        <b-col
                          cols="12"
                          md="6"
                          lg="4"
                        >
                          <b-form-group>
                            <label>City</label>
                            <validation-provider
                              v-slot="{ errors }"
                              :name="'City' + index"
                              rules="required"
                            >
                              <b-form-input
                                id="contact_info_address_city"
                                v-model="contactInfo.address.city"
                                :state="errors.length > 0 ? false:null"
                              />
                              <small
                                class="text-danger"
                                v-text="errors[0] !== undefined ? errors[0].replace('City' + index, 'City') : ''"
                              />
                            </validation-provider>
                          </b-form-group>
                        </b-col>
                        <b-col
                          cols="12"
                          md="6"
                          lg="4"
                        >
                          <b-form-group>
                            <label>State</label>
                            <validation-provider
                              v-slot="{ errors }"
                              :name="'State' + index"
                              rules="required"
                            >
                              <v-select
                                id="contact_info_address_state"
                                v-model="contactInfo.address.state_id"
                                :options="states"
                                :reduce="item => item.id"
                                :clearable="false"
                                placeholder="Select"
                              />
                              <small
                                class="text-danger"
                                v-text="errors[0] !== undefined ? errors[0].replace('State' + index, 'State') : ''"
                              />
                            </validation-provider>
                          </b-form-group>
                        </b-col>
                        <b-col
                          cols="12"
                          md="6"
                          lg="4"
                        >
                          <b-form-group>
                            <label>Zip Code</label>
                            <validation-provider
                              v-slot="{ errors }"
                              :name="'Zip Code' + index"
                              rules="required|integer|digits:5"
                            >
                              <b-form-input
                                id="contact_info_address_zip"
                                v-model="contactInfo.address.zip_id"
                                :state="errors.length > 0 ? false:null"
                              />
                              <small
                                class="text-danger"
                                v-text="errors[0] !== undefined ? errors[0].replace('Zip Code' + index, 'Zip Code') : ''"
                              />
                            </validation-provider>
                          </b-form-group>
                        </b-col>
                      </b-row>
                    </div>
                    <div class="right mt-1 ml-1">
                      <b-button
                        id="contact_info_remove"
                        v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                        variant="outline-danger"
                        class="btn-icon rounded-circle"
                        @click="removeContactInfo(index)"
                      >
                        <feather-icon
                          icon="XIcon"
                        />
                      </b-button>
                    </div>
                  </div>
                </b-col>
                <b-col cols="12">
                  <hr class="my-0">
                </b-col>
              </b-row>
            </div>
            <div v-if="contactTypes.length !== addEmployee.contact_information.length">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="outline-primary"
                class="ml-1"
                @click="addContactInformation"
              >
                <feather-icon
                  icon="PlusIcon"
                  class="mr-25"
                />
                <span>Add Additional Contact</span>
              </b-button>
            </div>
          </app-timeline-item>

          <app-timeline-item
            variant="primary"
            class="pb-1"
          >
            <div class="d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0">
              <h6>Compensation</h6>
            </div>
            <b-row>
              <b-col
                cols="12"
                md="6"
                lg="4"
              >
                <b-form-group>
                  <label>Salary Type</label>
                  <validation-provider
                    v-slot="{ errors }"
                    name="Salary Type"
                    rules="required"
                  >
                    <v-select
                      id="compensation_type"
                      v-model="addEmployee.compensation.type_id"
                      :options="salaryTypes"
                      :reduce="item => item.id"
                      :clearable="false"
                      placeholder="Select"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                cols="12"
                md="6"
                lg="4"
              >
                <b-form-group>
                  <label>Amount</label>
                  <validation-provider
                    v-slot="{ errors }"
                    name="Amount"
                    rules="required"
                  >
                    <b-input-group
                      prepend="$"
                    >
                      <money
                        v-model="addEmployee.compensation.amount"
                        :min="0"
                        :step="0.5"
                        v-bind="money"
                        class="form-control"
                      />
                    </b-input-group>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                cols="12"
                md="6"
                lg="4"
              >
                <b-form-group>
                  <label>Frequency</label>
                  <validation-provider
                    v-slot="{ errors }"
                    name="Frequency"
                    rules="required"
                  >
                    <v-select
                      id="compensation_frequency"
                      v-model="addEmployee.compensation.frequency_id"
                      :options="frequencies"
                      :reduce="item => item.id"
                      :clearable="false"
                      placeholder="Select"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
          </app-timeline-item>

          <app-timeline-item
            variant="info"
            class="pb-1"
          >
            <div class="d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0">
              <h6>Benefits</h6>
            </div>
            <b-row>
              <b-col
                cols="12"
                md="6"
                lg="4"
              >
                <b-form-group>
                  <label>Federal Holidays</label>
                  <validation-provider
                    v-slot="{ errors }"
                    name="Federal Holidays"
                    rules="integer"
                  >
                    <b-form-input
                      id="federal_holidays"
                      v-model="addEmployee.benefit.federal_holidays"
                      :state="errors.length > 0 ? false:null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                cols="12"
                md="6"
                lg="4"
              >
                <b-form-group>
                  <label>Vacation Days</label>
                  <validation-provider
                    v-slot="{ errors }"
                    name="Vacation Days"
                    rules="integer"
                  >
                    <b-form-input
                      id="vacation_days"
                      v-model="addEmployee.benefit.vacation_days"
                      :state="errors.length > 0 ? false:null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                cols="12"
                md="6"
                lg="4"
              >
                <b-form-group>
                  <label>Sick Days</label>
                  <validation-provider
                    v-slot="{ errors }"
                    name="Sick Days"
                    rules="integer"
                  >
                    <b-form-input
                      id="sick_days"
                      v-model="addEmployee.benefit.sick_days"
                      :state="errors.length > 0 ? false:null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                cols="12"
                md="6"
                lg="4"
              >
                <b-form-group>
                  <label>Medical Insurance</label>
                  <b-input-group
                    prepend="$"
                  >
                    <money
                      id="medical_insurance"
                      v-model="addEmployee.benefit.medical_insurance"
                      :min="0"
                      :step="0.5"
                      v-bind="money"
                      class="form-control"
                    />
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col
                cols="12"
                md="6"
                lg="4"
              >
                <b-form-group>
                  <label>401k Match</label>
                  <b-input-group
                    prepend="%"
                  >
                    <money
                      id="401k_match"
                      v-model="addEmployee.benefit.match_401K"
                      :min="0"
                      :step="0.5"
                      v-bind="money"
                      class="form-control"
                    />
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col
                cols="12"
                md="6"
                lg="4"
              >
                <b-form-group>
                  <label>Educational Reimbursement</label>
                  <b-input-group
                    prepend="$"
                  >
                    <money
                      id="educational_reimbursement"
                      v-model="addEmployee.benefit.educational_reimbursement"
                      :min="0"
                      :step="0.5"
                      v-bind="money"
                      class="form-control"
                    />
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
          </app-timeline-item>

          <app-timeline-item
            variant="success"
            class="pb-1"
          >
            <div class="d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0">
              <h6>Business Partners</h6>
            </div>
            <b-row
              v-for="(businessPartner, businessPartnerIndex) in business_partners"
              :id="businessPartnerIndex"
              :key="businessPartnerIndex"
              ref="form"
              class="repeater-form"
            >
              <b-col cols="12">
                <div class="d-flex">
                  <div class="left w-100">
                    <b-row>
                      <b-col
                        cols="12"
                        md="6"
                        lg="4"
                      >
                        <b-form-group>
                          <label>Partner Type</label>
                          <validation-provider
                            v-slot="{ errors }"
                            :name="'Partner Type' + businessPartnerIndex"
                            rules="required"
                          >
                            <v-select
                              v-model="businessPartner.parent_type_id"
                              :options="parentTypes"
                              :reduce="item => item.parent_type_id"
                              :clearable="false"
                              placeholder="Select Business Partner"
                              @input="parentTypeMatch(businessPartner.parent_type_id, businessPartnerIndex)"
                            />
                            <small
                              class="text-danger"
                              v-text="errors[0] !== undefined ? errors[0].replace('Partner Type' + businessPartnerIndex, 'Partner Type') : ''"
                            />
                          </validation-provider>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col
                        cols="12"
                        md="6"
                        lg="4"
                      >
                        <b-form-group>
                          <label>Name</label>
                          <validation-provider
                            v-slot="{ errors }"
                            :name="businessPartner.parent_type"
                            :rules="'required'"
                          >
                            <v-select
                              :id="businessPartner.partner"
                              v-model="businessPartner.user_id"
                              :options="businessPartner.parents"
                              :reduce="item => item.id"
                              :clearable="true"
                              placeholder="Select"
                            />
                            <small class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-form-group>
                      </b-col>
                      <b-col
                        cols="12"
                        md="8"
                      >
                        <b-row>
                          <b-col
                            cols="12"
                            md="6"
                            lg="4"
                          >
                            <b-form-group>
                              <label>Payment Frequency</label>
                              <validation-provider
                                v-slot="{ errors }"
                                :name="businessPartner.parent_type + ' Payment Frequency'"
                                :rules="'required'"
                              >
                                <v-select
                                  v-model="businessPartner.type_id"
                                  :options="salaryTypes"
                                  :reduce="item => item.id"
                                  :clearable="true"
                                  placeholder="Select"
                                />
                                <small class="text-danger">{{ errors[0] }}</small>
                              </validation-provider>
                            </b-form-group>
                          </b-col>
                          <b-col
                            cols="12"
                            md="6"
                            lg="4"
                          >
                            <b-form-group>
                              <label>Pay Rate</label>
                              <validation-provider
                                v-slot="{ errors }"
                                :name="businessPartner.parent_type + ' Pay Rate'"
                                rules="required"
                              >
                                <b-input-group
                                  prepend="$"
                                >
                                  <money
                                    v-model="businessPartner.amount"
                                    :min="0"
                                    :step="0.5"
                                    v-bind="money"
                                    class="form-control"
                                  />
                                </b-input-group>
                                <small class="text-danger">{{ errors[0] }}</small>
                              </validation-provider>
                            </b-form-group>
                          </b-col>
                          <b-col
                            cols="12"
                            md="6"
                            lg="4"
                          >
                            <b-form-group>
                              <label>Discount</label>
                              <validation-provider
                                v-slot="{ errors }"
                                :name="businessPartner.parent_type + ' Discount'"
                                rules="required"
                              >
                                <b-input-group
                                  prepend="%"
                                >
                                  <money
                                    id="employer_discount"
                                    v-model="businessPartner.discount"
                                    :min="0"
                                    :step="0.5"
                                    v-bind="money"
                                    class="form-control"
                                  />
                                </b-input-group>
                                <small class="text-danger">{{ errors[0] }}</small>
                              </validation-provider>
                            </b-form-group>
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-row>
                  </div>
                  <div class="right mt-1 ml-1">
                    <b-button
                      id="business_partner_remove"
                      v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                      variant="outline-danger"
                      class="btn-icon rounded-circle"
                      @click="removeBusinessPartner(businessPartnerIndex)"
                    >
                      <feather-icon
                        icon="XIcon"
                      />
                    </b-button>
                  </div>
                </div>
              </b-col>
              <b-col cols="12">
                <hr class="mt-0">
              </b-col>
            </b-row>
            <div>
              <b-button
                v-show="parentTypes.length > business_partners.length"
                id="add_contact_info"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="outline-primary"
                @click="addBusinessPartner"
              >
                <feather-icon
                  icon="PlusIcon"
                  class="mr-25"
                />
                <span>Add Business Partner</span>
              </b-button>
            </div>
          </app-timeline-item>

          <app-timeline-item
            variant="success"
            class="pb-1"
          >
            <div class="d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0">
              <h6>Documents</h6>
            </div>
            <b-row class="mt-1">
              <b-col cols="12">
                <div class="table-responsive">
                  <table class="table b-table table-th-pd table-td-pd">
                    <thead>
                      <tr>
                        <th>Document Type</th>
                        <th>Issuer</th>
                        <th>Name</th>
                        <th>Version</th>
                        <th class="th-minw-125">Upload Date</th>
                        <th class="th-minw-110">Exp Date</th>
                        <th>Uploaded By</th>
                        <th>Reminder</th>
                        <th>Document</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(priviousVersion, index) in addEmployee.documents"
                        :key="index"
                      >
                        <td>{{ priviousVersion.document_type }}</td>
                        <td>{{ priviousVersion.issuer }}</td>
                        <td>{{ priviousVersion.document_name }}</td>
                        <td>{{ priviousVersion.version }}</td>
                        <td>{{ priviousVersion.uploaded_date }}</td>
                        <td>{{ priviousVersion.exp_date }}</td>
                        <td>{{ priviousVersion.uploaded_by }}</td>
                        <td>{{ priviousVersion.reminder }}</td>
                        <td>
                          <b-link
                            target="_blank"
                            :href="priviousVersion.document_path"
                          >
                            <b-badge
                              variant="primary"
                              class="mr-1 mb-50"
                            >
                              <span>{{ priviousVersion.document }}</span>
                            </b-badge>
                          </b-link>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </b-col>
            </b-row>
            <div
              v-if="addEmployee.documents.length == 0"
              class="text-center"
            >
              <p> No Documents available </p>
            </div>
          </app-timeline-item>

          <app-timeline-item
            variant="danger"
            class="pb-1"
          >
            <div class="d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0">
              <h6>Comments</h6>
            </div>
            <b-row>
              <b-col
                v-for="(comment, index) in addEmployee.comments"
                :key="index"
                cols="12"
                md="6"
                lg="6"
                xl="4"
              >
                <div class="d-flex">
                  <div class="left w-100">
                    <b-form-group>
                      <label>Comment</label>
                      <b-form-textarea
                        v-model="comment.comment"
                        rows="2"
                      />
                    </b-form-group>
                  </div>
                  <div class="right mt-1 ml-1">
                    <b-button
                      v-show="index === 0"
                      variant="outline-primary"
                      class="btn-icon rounded-circle"
                      @click="addComment"
                    >
                      <feather-icon icon="PlusIcon" />
                    </b-button>
                    <b-button
                      v-show="index !== 0"
                      variant="outline-danger"
                      class="btn-icon rounded-circle"
                      @click="removeComment(index)"
                    >
                      <feather-icon icon="XIcon" />
                    </b-button>
                  </div>
                </div>
              </b-col>
            </b-row>
          </app-timeline-item>

          <app-timeline-item
            v-show="addEmployee.user_defined_fields.length !== 0"
            variant="primary"
            class="pb-1"
          >
            <div class="d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0">
              <h6>User Defined Fields</h6>
            </div>
            <b-row>
              <b-col
                v-for="field in addEmployee.user_defined_fields"
                :id="field.id"
                :key="field.id"
                cols="12"
                md="6"
                lg="4"
              >
                <b-form-group v-if="field.type.toLowerCase() === 'input'">
                  <label>{{ field.name }}</label>
                  <validation-provider
                    v-slot="{ errors }"
                    :name="field.name"
                    :rules="field.required ? 'required' : ''"
                  >
                    <b-form-input
                      v-model="field.value"
                      :state="errors.length > 0 ? false:null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
                <b-form-group v-if="field.type.toLowerCase() === 'dropdown'">
                  <label>{{ field.name }}</label>
                  <validation-provider
                    v-slot="{ errors }"
                    :name="field.name"
                    :rules="field.required ? 'required' : ''"
                  >
                    <v-select
                      v-model="field.value"
                      :options="field.options"
                      label="option"
                      :reduce="item => item.option"
                      :clearable="!field.required"
                      placeholder="Select"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
                <b-form-group v-if="field.type.toLowerCase() === 'textarea'">
                  <label>{{ field.name }}</label>
                  <validation-provider
                    v-slot="{ errors }"
                    :name="field.name"
                    :rules="field.required ? 'required' : ''"
                  >
                    <b-form-textarea
                      v-model="field.value"
                      rows="2"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
          </app-timeline-item>
        </app-timeline>
        <hr>

        <b-row class="mt-1">
          <b-col class="text-right">
            <b-button
              variant="primary"
              type="button"
              @click="submitForm"
            >
              Update Employee
            </b-button>
          </b-col>
        </b-row>

      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import vSelect from 'vue-select'
import {
  BCard, BRow, BCol, BForm, BLink, BFormGroup, BInputGroup, BInputGroupAppend, BFormInput, BFormTextarea, BButton, BFormCheckbox, BBadge,
} from 'bootstrap-vue'
import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'
import Ripple from 'vue-ripple-directive'
import {
  required,
} from '@validations'
import flatPickr from 'vue-flatpickr-component'
import Employee from '@/js/employees'
import LIST from '@/js/lists'
import moment from 'moment'
import Constants from '@/js/constant'
import Technology from '@/js/skillstechnologies'
import User from '@/js/user'

export default {
  name: 'EmployeeEdit',
  components: {
    BCard,
    AppTimeline,
    AppTimelineItem,
    ValidationProvider,
    ValidationObserver,
    BRow,
    BCol,
    BForm,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    BFormTextarea,
    vSelect,
    BButton,
    BFormCheckbox,
    flatPickr,
    BBadge,
    // currency,
  },
  directives: {
    Ripple,
  },
  setup() {
  },
  data() {
    return {
      user: User,
      required,
      task_data: {
        email: '',
        phone: '',
        name: '',
      },
      addEmployee: {
        first_name: '',
        middle_name: '',
        last_name: '',
        email_address: '',
        phone_number: '',
        ssn: '',
        gender_id: null,
        date_of_birth: null,
        employee_start_date: null,
        employee_end_date: null,
        contract_start_date: null,
        contract_end_date: null,
        client_id: null,
        status_id: null,
        skill_ids: null,
        passport_number: '',
        is_billable: false,
        visa: {
          type_id: null,
          expiration_date: null,
          validated: false,
        },
        status: {
          id: '',
          name: '',
        },
        address: {
          address1: '',
          address2: '',
          city: '',
          zip_id: '',
          state_id: null,
        },
        compensation: {
          type_id: null,
          amount: '',
          frequency_id: null,
        },
        benefit: {
          federal_holidays: '',
          vacation_days: '',
          sick_days: '',
          medical_insurance: '',
          k_match: '',
          educational_reimbursement: '',
        },
        parent_type: null,
        business_partners: [],
        employer_details: {
          user_id: null,
          type_id: null,
          amount: '',
          discount: '',
        },
        supplier_details: {
          user_id: null,
          type_id: null,
          amount: '',
          discount: '',
        },
        referrer_details: {
          user_id: null,
          type_id: null,
          amount: '',
          discount: '',
        },
        vendor_details: {
          user_id: null,
          type_id: null,
          amount: '',
          discount: '',
        },
        subvendor_details: {
          user_id: null,
          type_id: null,
          amount: '',
          discount: '',
        },
        contact_information: [],
        comments: [],
        documents: [],
        user_defined_fields: [],
        technologies: [],
      },
      options: {
        number: {
          numeral: true,
          numeralThousandsGroupStyle: 'thousand',
        },
      },
      money: {
        decimal: '.',
        thousands: ',',
        prefix: '',
        suffix: '',
        precision: 2,
        masked: false,
      },
      money1: {
        decimal: '.',
        thousands: ',',
        prefix: '',
        suffix: '',
        precision: 1,
        masked: false,
      },
      parentTypes: [],
      business_partners: [],
      date_of_birth: null,
      employee_start_date: null,
      employee_end_date: null,
      contract_start_date: null,
      contract_end_date: null,
      visa_expairy_date: null,
      selectedSkills: null,
      selectedRoles: null,
      selectedFile: null,
      documentNameId: null,
      genders: [],
      status: [],
      endClients: [],
      skills: [],
      roles: [],
      visaTypes: [],
      states: [],
      contactTypes: [],
      salaryTypes: [],
      frequencies: [],
      employers: [],
      suppliers: [],
      referrers: [],
      vendors: [],
      subVendors: [],
      technologies: [],
      documentNames: [],
      nextTodoId: 1,
    }
  },
  watch: {
    '$store.state.lists.commonLists': {
      immediate: true,
      handler() {
        LIST.getHRBusinessPartnerParentTypes(this)
        LIST.getStatesFullList(this)
        LIST.getVisaFullList(this)
        LIST.getFrequencyFullList(this)
        LIST.getGenderFullList(this)
        LIST.getSkillsFullList(this)
        LIST.getEndClientsFullList(this)
        LIST.getEmployersFullList(this)
        LIST.getSuppliersFullList(this)
        LIST.getReferrersFullList(this)
        LIST.getVendorsFullList(this)
        LIST.getSubVendorsFullList(this)
        LIST.getContactTypesFullList(this)
        LIST.getCompensationFullList(this)
        LIST.getTechnologies(this)
        this.setBusinessPartnerParents()
      },
    },
    '$store.state.lists.hrLists': {
      immediate: true,
      handler() {
        LIST.getEmployeeStatusFullList(this)
        LIST.getEmployeesDocumentNameFullList(this)
      },
    },
  },
  mounted() {
  },
  created() {
    LIST.getHRBusinessPartnerParentTypes(this)
    LIST.getStatesFullList(this)
    LIST.getEmployeeStatusFullList(this)
    LIST.getVisaFullList(this)
    LIST.getEmployeesDocumentNameFullList(this)
    LIST.getFrequencyFullList(this)
    LIST.getGenderFullList(this)
    LIST.getSkillsFullList(this)
    LIST.getCompensationFullList(this)
    LIST.getEndClientsFullList(this)
    LIST.getEmployersFullList(this)
    LIST.getSuppliersFullList(this)
    LIST.getReferrersFullList(this)
    LIST.getVendorsFullList(this)
    LIST.getSubVendorsFullList(this)
    LIST.getContactTypesFullList(this)
    LIST.getTechnologies(this)
    Employee.getEmployeeById(this, this.$route.params.id)
  },
  destroyed() {
  },
  methods: {
    submitForm() {
      this.$refs.simpleRules.validate().then(result => {
        if (result) {
          if (this.date_of_birth !== null) {
            this.addEmployee.date_of_birth = Constants.getEprmMonthDateFromString(this.date_of_birth)
          } else {
            this.addEmployee.date_of_birth = null
          }
          if (this.employee_start_date !== null) {
            this.addEmployee.employee_start_date = Constants.getEprmMonthDateFromString(this.employee_start_date)
          } else {
            this.addEmployee.employee_start_date = null
          }
          if (this.employee_end_date !== null) {
            this.addEmployee.employee_end_date = Constants.getEprmMonthDateFromString(this.employee_end_date)
          } else {
            this.addEmployee.employee_end_date = null
          }
          if (this.contract_start_date !== null) {
            this.addEmployee.contract_start_date = Constants.getEprmMonthDateFromString(this.contract_start_date)
          } else {
            this.addEmployee.contract_start_date = null
          }
          if (this.contract_end_date !== null) {
            this.addEmployee.contract_end_date = Constants.getEprmMonthDateFromString(this.contract_end_date)
          } else {
            this.addEmployee.contract_end_date = null
          }
          if (this.visa_expairy_date !== null) {
            this.addEmployee.visa.expiration_date = Constants.getEprmMonthDateFromString(this.visa_expairy_date)
          } else {
            this.addEmployee.visa.expiration_date = null
          }
          this.addEmployee.business_partners = []
          this.business_partners.forEach(businessPartner => {
            const parentDetails = {
              parent_type_id: businessPartner.parent_type_id,
              user_id: businessPartner.user_id,
              type_id: businessPartner.type_id,
              amount: businessPartner.amount,
              discount: businessPartner.discount,
            }
            this.addEmployee.business_partners.push(parentDetails)
          })
          this.showLoading = true
          Employee.updateEmployee(this, this.$route.params.id, this.addEmployee)
        }
      })
    },
    addBusinessPartner() {
      const parentDetails = {
        parent_type_id: null,
        parents: [],
        parent: '',
        user_id: null,
        type_id: null,
        amount: '',
        discount: '',
      }
      this.business_partners.push(parentDetails)
    },
    skillSelected() {
      Technology.getTechnologiesBySkillIds(this, this.addEmployee.skill_ids)
    },
    setSkillTechnologies(technologies) {
      const existingTechnologyIds = []
      const newTechnologyIds = []
      for (let i = 0; i < this.addEmployee.technologies.length; i += 1) {
        existingTechnologyIds.push(this.addEmployee.technologies[i].technology_id)
      }
      for (let i = 0; i < technologies.length; i += 1) {
        newTechnologyIds.push(technologies[i].id)
      }
      this.addEmployee.technologies = this.addEmployee.technologies.filter(technology => technology.experience !== 0 || technology.rating !== 0 || newTechnologyIds.includes(technology.technology_id))

      technologies.forEach(technology => {
        if (!existingTechnologyIds.includes(technology.id)) {
          const newTechnology = {
            technology_id: technology.id,
            rating: 0,
            experience: 0,
          }
          this.addEmployee.technologies.push(newTechnology)
        }
      })
    },
    setPartners(parentTypes) {
      this.parentTypes = parentTypes
    },
    setTechnologies(technologies) {
      this.technologies = technologies
    },
    technologyTypeMatch(technologyId, index) {
      if (this.addEmployee.technologies.filter(technology => technology.technology_id === technologyId).length > 1) {
        this.addEmployee.technologies[index].technology_id = null
      }
    },
    contactTypeMatch(typeId, index) {
      if (this.addEmployee.contact_information.filter(contactInformation => contactInformation.type_id === typeId).length > 1) {
        this.addEmployee.contact_information[index].type_id = null
      }
    },
    parentTypeMatch(typeId, index) {
      this.business_partners[index].user_id = null
      if (this.business_partners.filter(businessPartner => businessPartner.parent_type_id === typeId).length > 1) {
        this.business_partners[index].parent_type_id = null
        return
      }
      const partner = this.parentTypes.find(parentType => parentType.parent_type_id === typeId)
      this.business_partners[index].parent_type = partner.label
      switch (partner.id) {
        case 'employer':
          this.business_partners[index].parents = this.employers
          break
        case 'vendors':
          this.business_partners[index].parents = this.vendors
          break
        case 'suppliers':
          this.business_partners[index].parents = this.suppliers
          break
        case 'referrer':
          this.business_partners[index].parents = this.referrers
          break
        case 'subvendor':
          this.business_partners[index].parents = this.subVendors
          break
        default:
          break
      }
    },
    attahamentFileSelected(obj) {
      const dis = this
      const fileReader = new FileReader()
      fileReader.onload = fileLoadEvent => {
        dis.selectedFile = fileLoadEvent.target.result
      }
      fileReader.readAsDataURL(obj.target.files[0])
      this.url = URL.createObjectURL(obj.target.files[0])
      this.documentName = obj.target.files[0].name
    },
    removeFile(file, position) {
      if (file.id == null) {
        this.addEmployee.documents.splice(position, 1)
      } else {
        this.deleteConfirm(file, position)
      }
    },
    deleteConfirm(obj, position) {
      this.$swal({
        title: 'Are you sure?',
        text: `you wan't to delete this ${obj.name}`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        customClass: {
          confirmButton: 'btn btn-danger',
          cancelButton: 'btn btn-outline-primary ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.addEmployee.documents.splice(position, 1)
        }
      })
    },
    addFile() {
      if (this.documentNameId !== null && this.selectedFile === null) {
        this.$swal({
          title: 'Error!',
          text: ' Please choose file',
          icon: 'error',
          customClass: {
            confirmButton: 'btn btn-primary',
          },
          buttonsStyling: false,
        })
        return
      }
      if (this.documentNameId === null && this.selectedFile !== null) {
        this.$swal({
          title: 'Error!',
          text: ' Please select document type',
          icon: 'error',
          customClass: {
            confirmButton: 'btn btn-primary',
          },
          buttonsStyling: false,
        })
        return
      }
      if (this.documentNameId !== null && this.selectedFile !== null) {
        this.addEmployee.documents.push({
          document_name_id: this.documentNameId, attachment_link: this.url, document: this.selectedFile, file_name: this.documentName, name: this.documentName,
        })
        this.selectedFile = null
        this.url = null
        this.documentNameId = null
        this.$refs.myFileInput.value = ''
      }
    },
    addEmployeeSkill() {
      const employeeSkill = {
        technology_id: null,
        rating: 0,
        experience: 0,
      }
      this.addEmployee.technologies.push(employeeSkill)
    },
    removeEmployeeSkill(index) {
      this.addEmployee.technologies.splice(index, 1)
    },
    addContactInformation() {
      const contactInfo = {
        type_id: null,
        contact_name: '',
        email_address: '',
        phone_number: '',
        address: {
          address1: '',
          address2: '',
          city: '',
          zip_id: '',
          state_id: null,
        },
      }
      this.addEmployee.contact_information.push(contactInfo)
    },
    repeateAgain() {
      this.items.push({
        id: this.nextTodoId += this.nextTodoId,
      })
    },
    removeContactInfo(index) {
      this.addEmployee.contact_information.splice(index, 1)
    },
    removeBusinessPartner(businessPartnerIndex) {
      this.business_partners.splice(businessPartnerIndex, 1)
    },
    setVisaTypes(visaTypes) {
      this.visaTypes = visaTypes
    },
    setDocumentNames(documentNames) {
      this.documentNames = documentNames
    },
    setFrequencies(frequencies) {
      this.frequencies = frequencies
    },
    setCompanies(companies) {
      this.companies = companies
    },
    setContactTypes(contactTypes) {
      this.contactTypes = contactTypes
    },
    setStatus(status) {
      this.status = status
    },
    setSalaryTypes(salaryTypes) {
      this.salaryTypes = salaryTypes
    },
    setGenders(genders) {
      this.genders = genders
    },
    setStates(states) {
      this.states = states
    },
    setEndClients(endClients) {
      this.endClients = endClients
    },
    setSkills(skills) {
      this.skills = skills
    },
    setRoles(roles) {
      this.roles = roles
    },
    setEmployers(employers) {
      this.employers = employers
    },
    setSuppliers(suppliers) {
      this.suppliers = suppliers
    },
    setReferrers(referrers) {
      this.referrers = referrers
    },
    setVendors(vendors) {
      this.vendors = vendors
    },
    setSubVendors(subVendors) {
      this.subVendors = subVendors
    },
    setPaymentFrequency(paymentFrequency) {
      this.paymentFrequency = paymentFrequency
    },
    removeEmployeeEndDate() {
      this.employee_end_date = null
    },
    removeContractStartDate() {
      this.contract_start_date = null
    },
    removeContractEndDate() {
      this.contract_end_date = null
    },
    removeVisaExpairyDate() {
      this.visa_expairy_date = null
    },
    setBusinessPartnerParents() {
      for (let i = 0; i < this.business_partners.length; i += 1) {
        switch (this.business_partners[i].parent_type) {
          case 'employer':
            this.business_partners[i].parents = this.employers
            break
          case 'vendors':
            this.business_partners[i].parents = this.vendors
            break
          case 'suppliers':
            this.business_partners[i].parents = this.suppliers
            break
          case 'referrer':
            this.business_partners[i].parents = this.referrers
            break
          case 'subvendor':
            this.business_partners[i].parents = this.subVendors
            break
          default:
            break
        }
      }
    },
    setEmployee(employee) {
      this.addEmployee = employee
      this.business_partners = employee.business_partners
      this.setBusinessPartnerParents()

      if (this.addEmployee.benefit === null) {
        this.addEmployee.benefit = {
          federal_holidays: '',
          vacation_days: '',
          sick_days: '',
          medical_insurance: '',
          k_match: '',
          educational_reimbursement: '',
        }
      }
      this.$store.state.taskDetails.name = `${employee.first_name} ${employee.last_name}`
      this.$store.state.taskDetails.email = employee.email_address
      this.$store.state.taskDetails.phone = employee.phone_number
      this.$store.state.taskDetails.type = 'parent'
      this.$store.state.taskDetails.task_type = 'parent'
      this.$store.state.taskDetails.parent_type = 'employee'
      if (this.addEmployee.compensation === null) {
        this.addEmployee.compensation = {
          type_id: null,
          amount: '',
          frequency_id: null,
        }
      } else {
        this.addEmployee.compensation.type_id = employee.compensation.compensation_type_id
      }
      // this.task_data.name = employee.first_name + ' ' + employee.last_name
      this.task_data.email = employee.email_address
      this.task_data.phone = employee.phone_number
      if (this.addEmployee.comments.length === 0) {
        this.addComment()
      }
      if (this.addEmployee.contact_information === null) {
        this.addEmployee.contact_information = []
      }
      this.selectedRoles = employee.roles
      this.previous_type = employee.type
      this.previous_type_id = employee.type_id
      this.addEmployee.status.id = employee.status.id
      if (employee.date_of_birth !== null) {
        this.date_of_birth = employee.date_of_birth
      }
      if (employee.contract_start_date !== null) {
        this.contract_start_date = employee.contract_start_date
      }
      if (employee.contract_end_date !== null) {
        this.contract_end_date = employee.contract_end_date
      }
      if (employee.employee_start_date !== null) {
        this.employee_start_date = employee.employee_start_date
      }
      if (employee.employee_end_date !== null) {
        this.employee_end_date = employee.employee_end_date
      }
      if (employee.visa.expiration_date !== null) {
        this.visa_expairy_date = employee.visa.expiration_date
      }
      if (employee.employer_details === null) {
        this.addEmployee.employer_details = {
          user_id: null,
          type_id: null,
          amount: '',
          discount: '',
        }
      }
      if (employee.subvendor_details === null) {
        this.addEmployee.subvendor_details = {
          user_id: null,
          type_id: null,
          amount: 0,
          discount: 0,
        }
      }
      if (employee.vendor_details === null) {
        this.addEmployee.vendor_details = {
          user_id: null,
          type_id: null,
          amount: '',
          discount: '',
        }
      }
      if (employee.supplier_details === null) {
        this.addEmployee.supplier_details = {
          user_id: null,
          type_id: null,
          amount: '',
          discount: '',
        }
      }
      if (employee.referrer_details === null) {
        this.addEmployee.referrer_details = {
          user_id: null,
          type_id: null,
          amount: '',
          discount: '',
        }
      }
    },
    employeeUpdated(data) {
      this.$refs.showLoading = false
      this.back()
      this.$swal({
        title: 'Success!',
        html: Constants.getParentSuccessMessage(data.return_message),
        icon: 'success',
        showCancelButton: true,
        confirmButtonText: Constants.getUploadButtonText(),
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-primary ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.isConfirmed) {
          this.$router.push(`/documents/document-tracker/new?parent_id=${data.id}&parent_type_id=${data.parent_type_id}`).catch(() => {})
        }
      })
    },
    employeeNotUpdated(message) {
      this.$refs.showLoading = false
      if (this.addEmployee.employer_details == null) {
        this.addEmployee.employer_details = {
          user_id: null, type_id: null, amount: '', discount: '',
        }
      }
      if (this.addEmployee.subvendor_details == null) {
        this.addEmployee.subvendor_details = {
          user_id: null, type_id: null, amount: '', discount: '',
        }
      }
      if (this.addEmployee.vendor_details == null) {
        this.addEmployee.vendor_details = {
          user_id: null, type_id: null, amount: '', discount: '',
        }
      }
      if (this.addEmployee.supplier_details == null) {
        this.addEmployee.supplier_details = {
          user_id: null, type_id: null, amount: '', discount: '',
        }
      }
      if (this.addEmployee.referrer_details == null) {
        this.addEmployee.referrer_details = {
          user_id: null, type_id: null, amount: '', discount: '',
        }
      }
      this.$swal({
        title: 'Error!',
        text: message,
        icon: 'error',
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        buttonsStyling: false,
      })
    },
    addComment() {
      const comment = {
        comment: '',
        date: Constants.getEprmMonthDateFromString(moment()),
        time: moment().format('hh:mm a'),
      }
      this.addEmployee.comments.push(comment)
    },
    removeComment(index) {
      this.addEmployee.comments.splice(index, 1)
    },
    back() {
      this.$router.go(-1)
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
.repeater-form {
  transition: .35s height;
}
</style>
